import React from 'react';
import { useNavigate } from 'react-router-dom';

const Credits = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#fdf6ec] flex items-center justify-center px-4">
      <div className="w-full max-w-sm text-center">

        <div className="mb-3">
          <span className="bg-[#ff6b35] text-white text-xs font-black tracking-[3px] uppercase px-3 py-1 rounded">
            FILMQUEST
          </span>
        </div>

        <div className="text-4xl mb-4">🎬</div>

        <h1 className="text-3xl font-black text-[#1a1a1a] mb-2">Credits</h1>
        <p className="text-sm text-[#888] mb-8">Made with love for movie buffs everywhere.</p>

        <div className="bg-white border-[3px] border-[#1a1a1a] rounded-xl p-5 shadow-[4px_4px_0_#1a1a1a] mb-6 text-left">
          <div className="mb-4">
            <p className="text-xs font-black text-[#ff6b35] uppercase tracking-widest mb-1">Game</p>
            <p className="text-sm font-bold text-[#1a1a1a]">FilmQuest</p>
            <p className="text-xs text-[#888]">Six Degrees of Separation — movie edition</p>
          </div>
          <div className="mb-4">
            <p className="text-xs font-black text-[#ff6b35] uppercase tracking-widest mb-1">Data</p>
            <p className="text-sm font-bold text-[#1a1a1a]">The Movie Database (TMDB)</p>
            <p className="text-xs text-[#888]">tmdb.org</p>
          </div>
          <div>
            <p className="text-xs font-black text-[#ff6b35] uppercase tracking-widest mb-1">Built with</p>
            <p className="text-sm font-bold text-[#1a1a1a]">React · Tailwind CSS · Node.js</p>
          </div>
        </div>

        <button
          onClick={() => navigate('/')}
          className="bg-[#ff6b35] text-white font-black text-base py-3 px-6 rounded-lg border-[3px] border-[#1a1a1a] shadow-[4px_4px_0_#1a1a1a] hover:shadow-[2px_2px_0_#1a1a1a] transition-shadow"
        >
          ← Back to Menu
        </button>

      </div>
    </div>
  );
};

export default Credits;
